import { SubHeading } from 'components/Typography/General';
import { useState } from 'react';

const BundleTestimonialSection = ({ testimonials }) => {
  const [selectedTestimonial, setSelectedTestimonial] = useState(testimonials[0]);
  const [startIndex, setStartIndex] = useState(0);

  const scrollLeft = () => {
    setStartIndex((prev) => Math.max(prev - 1, 0));
  };

  const scrollRight = () => {
    setStartIndex((prev) => Math.min(prev + 1, testimonials.length - 5));
  };

  const isActive = (testimonial) => {
    return testimonial.reviewer === selectedTestimonial.reviewer;
  };

  const authorsToDisplay = 5;

  return (
    <div className="customer-wrapper testimonials-container">
      <SubHeading variety={3} className="section-title">
        Testimonials
      </SubHeading>
      <div>
        <div className="testimonial">
          <div className="quote">“</div>
          <p>{selectedTestimonial.review}</p>
        </div>
      </div>
      <div style={{ display: 'flex', position: 'relative' }}>
        {testimonials.length > authorsToDisplay && (
          <img
            src="/global/chevron_right.svg"
            className={'testimonial-navigation-arrow left'}
            onClick={scrollLeft}
            alt="chevronLeft"
            style={startIndex > 0 ? { rotate: '180deg' } : { display: 'none' }}
          />
        )}
        <div className={`testimonial-user-container`}>
          {testimonials.slice(startIndex, startIndex + authorsToDisplay).map((testimonial, index) => {
            return (
              <div
                key={index}
                style={{ position: 'relative' }}
                className={isActive(testimonial) ? 'selected' : ''}
                onClick={() => setSelectedTestimonial(testimonial)}
              >
                {isActive(testimonial) && <div className="testimonial-bubble-arrow" />}
                <img
                  src={testimonial?.image?.path ? testimonial.image.path : '/dummy-avatar-svg.svg'}
                  className="customer-avatar"
                />
                {isActive(testimonial) && (
                  <div className="details">
                    <div className="bold">{testimonial.reviewer}</div>
                    <div className="light">{testimonial.organization}</div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        {testimonials.length > authorsToDisplay && (
          <img
            src="/global/chevron_right.svg"
            style={startIndex < testimonials.length - authorsToDisplay ? {} : { display: 'none' }}
            className={'testimonial-navigation-arrow right'}
            onClick={scrollRight}
            alt="chevronRight"
          />
        )}
      </div>
    </div>
  );
};

export default BundleTestimonialSection;
